import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '^zoid-definitions/mockXprops';
import logger from '^utils/logger';
import gtmHelper from '^utils/gtmHelper';

import App from './App';

// @cars4ever/public-ui@0.0.86 (unlike the legacy @interdan package) does NOT self-inject its
// global stylesheet — it ships the base globals (@font-face Poppins, :root design tokens,
// box-sizing, html/body resets) in dist/index.css, which consumers must import explicitly.
// Loaded before ^scss-global so the app's own globals override where they overlap.
import '@cars4ever/public-ui/dist/index.css';

import '^scss-global';

logger.init();
gtmHelper.init();

const container = document.getElementById('root');

if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
